import axios from "axios";

export const getProductionOrderOee = async (machineId, itemNo, companyKey) => {

    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/OEEData/historicoee?machineId=${machineId}&itemNo=${itemNo}&companyKey=${companyKey}`);
    const data = response.data;
    return data;
}

export const getAllProductionOrderOee = async (companyKey) => {

    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/OEEData/historicoee-all?companyKey=${companyKey}`);
    const data = response.data;
    return data;
}

export const getProductionOrderHistoryByTool = async (toolId, companyKey) => {

    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/OEEData/historicoee-bytool?toolId=${toolId}&companyKey=${companyKey}`);
    const data = response.data;
    return data;
}
